<template>
  <v-card elevation="5" outlined shaped>
    <v-dialog v-model="carreraModal" max-width="600" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>CARRERA</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersCarrera"
                  :items="datosCarrera"
                  :items-per-page="5"
                  @click:row="($event, {item})=>seleccionarCarrera(item)"
                   class="elevation-1"
                  id="tableId"
                  hide-default-footer
                  disable-pagination
                >
                  <!--template #[`item.actions`]="{ item }">
                    <v-icon
                      color="blue"
                      small
                      class="mr-2"
                      @click="seleccionarCarrera(item)"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template-->
                </v-data-table>
              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="#EE680B"
                  @click="closeCarrera"
                  style="float: right"
                  title="SALIR"
                >
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="gestionModal" max-width="400" class="text-cenet">
      <v-card elevation="5" outlined shaped>
        <v-card-title>
          <span>
            <h5>GESTION</h5>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersGestion"
                  :items="datosGestion"
                  :items-per-page="5"
                  @click:row="($event, {item})=>seleccionarGestion(item)"
                  class="elevation-1"
                  id="tableId"
                  hide-default-footer
                  disable-pagination
                >
                  <!--template #[`item.actions`]="{ item }">
                    <v-icon
                      color="#0091EA"
                      small
                      class="mr-2"
                      @click="seleccionarGestion(item)"
                      title="SELECCIONAR GESTION"
                    >
                      mdi-check-circle
                    </v-icon>
                  </template-->
                </v-data-table>
              </v-col>
              <v-col cols="10"> </v-col>
              <v-col cols="2">
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="#EE680B"
                  @click="closeGestion"
                  style="float: right"
                  title="SALIR"
                >
                  <v-icon dark> mdi-close-circle-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div>
      <v-alert dense color="#EE680B" style="color: #ffffff">
        <h5>PAGO ONLINE EN BOLVIANOS</h5>
      </v-alert>
    </div>

    <v-list-item>
      <v-list-item-title class="text-center">
        <h4>DATOS PARA LA FACTURA</h4>
      </v-list-item-title>
    </v-list-item>
    <div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
               <v-btn 
             rounded
                   color="#002245"
                    class="ma-2 white--text"
                     @click="showCarrera()"
                     
                    >
                  SELECCIONA TU  CARRERA
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-school-outline
              </v-icon>
           </v-btn>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="carrera"
                label="CARRERA"
                disabled
                required
              ></v-text-field>
            </v-col>

          
            <v-col cols="12" md="12">
               <v-btn 
             rounded
                   color="#EE680B"
                    class="ma-2 white--text"
                     @click="showGestion()"
                     
                    >
                  SELECCIONA TU  GESTION
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-calendar-clock-outline
              </v-icon>
           </v-btn>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="gestion"
                label="GESTION"
                disabled
                required
              ></v-text-field>
            </v-col>
<v-col cols="12" md="12">
              <div>
                <br />
                <br />
                <v-alert dense color="#21618C" style="color: #ffffff">
                  <h5>
                    ESCRIBE EL EMAIL AL QUE ENVIAREMOS TU FACTURA
                  </h5>
                </v-alert>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="email_cliente"
                :rules="emailRules"
                type="email"
                :value="2"
                label="EMAIL"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <div>
                <br />
                <br />
                <v-alert dense color="#21618C" style="color: #ffffff">
                  <h5>
                    ESCRIBE LA RAZON SOCIAL PARA TU FACTURA
                  </h5>
                </v-alert>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="nombreFactura"
                :counter="30"
                :rules="nombreRules"
                @input="nombreFactura = nombreFactura.toUpperCase()"
                label="RAZON SOCIAL/APELLIDO"
                required
              ></v-text-field>
            </v-col>
            
<v-col cols="12" md="12">
              <div>
                <br />
                <br />
                <v-alert dense color="#21618C" style="color: #ffffff">
                  <h5>
                    SELECCIONA UN TIPO DE DOCUMENTO PARA TU FACTURA
                  </h5>
                </v-alert>
              </div>
            </v-col>
         <v-col cols="12" md="12">
              <v-select
                v-model="selectDocumento"
                :items="datosDocumento"
                :rules="tipoDocRules"
                item-text="sex"
                item-value="sex"
                label="DOCUMENTO"
                filled
                dense
                required
                solo
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="12">
              <div>
                <br />
                <br />
                <v-alert dense color="#21618C" style="color: #ffffff">
                  <h5>
                    ESCRIBE EL NIT PARA TU FACTURA
                  </h5>
                </v-alert>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                :rules="numDocRules"
                v-model="numeroNit"
                :counter="20"
                @input="numeroNit = numeroNit.toUpperCase()"
                :value="1"
                label="NÚMERO DOCUMENTO/NIT"
                required
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <div>
                <br />
                <br />
                <v-alert dense color="#21618C" style="color: #ffffff">
                  <h4>
                    Estimado(a) Estudiante, una vez efectuado su pago, no podrá
                    solicitar cambios, anulación de factura, u otros. Antes de
                    elegir el boton de PAGAR, será importante que verifique, los
                    datos que ha registrado.
                  </h4>
                </v-alert>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="6">
              <!--<v-col cols="10">
                <v-list-item>
                  <v-list-item-title class="text-center">
                    <h5>{{ carrera }}</h5>
                  </v-list-item-title>
                </v-list-item>
                ANTIGUO METODO DE SELECCION DE PAGO
                <v-data-table
                  v-model="Seleccionados"
                  :single-select="singleSelect"
                  item-key="iddeucon"
                  show-select
                  :headers="headersDeuda"
                  :items="datosDeuda"
                  :items-per-page="10"
                  :footer-props="{
                    itemsPerPageText: 'DATOS POR PAGINA',
                  }"
                  class="elevation-1"
                  id="tableId"
                  hide-default-footer
                  disable-pagination
                  @click:row="($event, {item})=>seleccionarItemapagar(item)"
                >
                 
                </v-data-table>-->
                <v-data-table
                :headers="headersDeuda"
                :items="datosDeuda"
                
                hide-default-footer
                    disable-pagination
                class="elevation-1"
                id="tableId"
              >
               
                <template #[`item.actions`]="{ item }">
                   <v-btn 
             rounded
                   color="#EE680B"
                    class="ma-2 white--text"
                     @click="seleccionarItemapagar(item)"
                    >
                  PAGAR
                    <v-icon
                    right
                   dark
                     large
                       >
                 mdi-cash
              </v-icon>
           </v-btn>
                  </template>
              </v-data-table>
              
            </v-col>

            <!--v-col cols="12" md="1"> </v-col>
            <v-col cols="12" md="10">
              <div>
                <v-btn
                  block
                  style="background-color: #e67e22; color: white"
                  text-color="white"
                  size="x-large"
                  @click="pagar()"
                >
                  <v-icon color="#FBFCFC" small class="mr-2">
                    mdi-credit-card-fast-outline
                  </v-icon>
                  PAGAR
                </v-btn>
              </div>
            </v-col-->
          </v-row>

          <div class="text-center">
            <v-snackbar
              v-model="snackbarOK"
              :timeout="timeout"
              top
              right
              shaped
              dense
              color="#EE680B"
              outlined
            >
              <strong>{{ mensajeSnackbar }}</strong>

              <template v-slot:action="{ attrs }">
                <v-icon right v-bind="attrs" @click="snackbarOK = false">
                  mdi-close
                </v-icon>
              </template>
            </v-snackbar>
          </div>
          <div class="text-center">
            <v-snackbar
              v-model="snackbarError"
              :timeout="timeout"
              top
              right
              shaped
              dense
              color="#EE680B"
              outlined
            >
              <strong>{{ mensajeSnackbarError }}</strong>

              <template v-slot:action="{ attrs }">
                <v-icon right v-bind="attrs" @click="snackbarError = false">
                  mdi-close
                </v-icon>
              </template>
            </v-snackbar>
          </div>
        </v-container>
      </v-form>
    </div>
  </v-card>
</template>
<script>
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

export default {
  data: () => ({
    accLevelIds: 1,
    deptCode: 1,
    singleSelect: "",
    idItem: "",
    callBack: "",
    datosItemsVerificados: [],
    transIdentificador: "",
    errorResult: "",
    message: "",
    invoiceDate: "",
    invoiceNumber: "",

    descUnitario: "",
    costoUnitario: "",
    concepto: "",
    codProducto: "",
    cantidad: "",
    numeroNit: "",
    nombreFactura: "",
    det: [],
    gggdet: [
      {
        concepto: "",
        cantidad: "",
        costo_unitario: "",
        descuento_unitario: "",
        codigo_producto: "",
        codigo_producto_sin: "",
      },
    ],
    post_data: [],
    Seleccionados: [],
    makeCall: "",
    jpago: "",
    jpago1: "",
    fechaFactura: "",
    md: [
      {
        nombre: "",
        dato: "",
      },
      {
        nombre: "",
        dato: "",
      },
      {
        nombre: "",
        dato: "",
      },
    ],
    meses: [
      "ENERO",
      "FEBRERO",
      "MARZO",
      "ABRIL",
      "MAYO",
      "JUNIO",
      "JULIO",
      "AGOSTO",
      "SEPTIEMBRE",
      "OCTUBRE",
      "NOVIEMBRE",
      "DICIEMBRE",
    ],
    cabecera: [],
    idDeuda: "",
    detalle: [],
    libelulaurl: "",
    gestion: "",
    idGestion: "",
    gestionModal: 0,
    datosGestion: [],
    datosDeuda: [],
    datosEstudiante: [],
    idPlanestudio: "",
    idCarrera: "",
    carrera: "",
    carreraModal: 0,
    datosCarrera: [],
    selectDocumento: "",
    datosDocumento: ["CI", "NIT", "PASAPORTE"],
    usuario: "",
    id_sede: "",
    nombreMateria: "",
    codigoMateria: "",
    nomus: "",
    patus: "",
    direccionBloque: "",
    valid: true,

    beneficiarioexp: "",
    id_beneex: "",
    tpostModal: "",
    searchMateria: "",
    datosexpbeneficiario: [],
    c: "",
    snackbarOK: false,
    mensajeSnackbar: "",
    snackbarError: false,
    mensajeSnackbarError: "REGISTRO FALLIDO ",
    timeout: 2000,
    email_cliente: "",
    botonAct: 0,
    idMateria: "",
    okk: "",
    appkey: "",
    identificador: "",
    callback_url: "",
    descripcion: "",
    nombre_cliente: "",
    apellido_cliente: "",
    codigo_cliente: "",
    numero_documento: "",
    razon_social: "",
    codigo_tipo_documento: "",
    codigo_documento_sector: "",

    nombreRules: [
      (v) => !!v || "NOMBRE ES REQUERIDO",
      (v) =>
        (v && v.length <= 30) ||
        "EL NOMBRE DEBE TENER 30 CARACTERES COMO MAXIMO",
    ],
    emailRules: [(v) => !!v || "EMAIL ES REQUERIDO"],

    numDocRules: [
      (v) => !!v || "NÚMERO DE DOCUMENTO ES REQUERIDO",
      (v) =>
        (v && v.length <= 20) ||
        "NÚMERO DE DOCUMENTO DEBE TENER 20 CARACTERES COMO MAXIMO",
    ],
    tipoDocRules: [(v) => !!v || "TIPO DE DOCUMENTO ES REQUERIDO"],
    headersCarrera: [
      { text: "CARRERA", value: "carre", sortable: false , class: 'my-header-style'},
      //{ text: "OPCIONES", value: "actions", sortable: false },
    ],

    checkbox: false,
    datosMateria: [],
    headersGestion: [
      { text: "GESTION", value: "nom", sortable: false, class: 'my-header-style' },
      //{ text: "OPCIONES", value: "actions", sortable: false },
    ],
    headersDeuda: [
      //{ text: "PLAN ECONOMICO", value: "planeconom", sortable: true },
      { text: "CONCEPTO", value: "item", sortable: false , class: 'my-header-style'},
      { text: "MONTO(Bs)", value: "deuda", sortable: false , class: 'my-header-style'},
      { text: "SELECCIONAR", value: "actions", sortable: false },
    ],
    det1: "",
    md1: "",
    det2: "",
    md2: "",
    headersItems: [
      { text: "ITEM", value: "codmat", sortable: false },
      { text: "DEUDA ", value: "nom", sortable: false },
      { text: "RECURSADA", value: "act", sortable: false },
      { text: "SIMULADOR", value: "codmat", sortable: false },
      { text: "CON.CONSULTIVO", value: "nom", sortable: false },
      { text: "PRACT. HOSPITALARIA", value: "act", sortable: false },
      { text: "TOTAL", value: "act", sortable: false },
      { text: "OPCIONES", value: "actions", sortable: false },
    ],
  }),

  created: function () {
    this.user = JSON.parse(sessionStorage.getItem("session"));
    this.usuario = this.user.personal;
    this.id_sede = this.user.id_sede;
    this.nombreCompleto =
    this.user.paterno + " " + this.user.materno + " " + this.user.nombres;
    this.paterno = this.user.paterno;
    this.materno = this.user.materno;
    this.nombres = this.user.nombres;
    this.unicodigo = this.user.unico;
    this.listarDatosEstudiante();
    this.extraerFecha();
  },

  methods: {
    async verificarIdentificadorLibelula() {
      let me = this;
      await axios
        .get(
          "/estudiante/verificarIdentificadorLibelula/" +
            this.identificador +
            "," +
            this.unicodigo +
            "," +
            this.id_sede +
            "," +
            this.idGestion
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosItemsVerificados = [];
          } else {
            me.datosItemsVerificados = response.data.resultado;
            //console.log(me.datosItemsVerificados);
          }
        })
        .catch(function (error) {});
    },
    async actualizarDatosFactura() {
      let me = this;

      //let me=this;
      await axios
        .post(
          "/estudiante/actualizarDatosParaFactura/" +
            this.nombreFactura +
            "," +
            this.email_cliente +
            "," +
            this.numeroNit +
            "," +
            this.selectDocumento +
            "," +
            this.unicodigo
        )
        .then(function (response) {})
        .catch(function (error) {
          me.snackbarError = true;
        });
    },

    generarNumeroDe16Digitos() {},

    extraerFecha() {
      const fecha = new Date();
      const añoActual = fecha.getFullYear();
      const mesActual = fecha.getMonth() + 1;
      this.fechaFactura = this.meses[mesActual - 1] + " " + añoActual;
    },
    seleccionarItemapagar(item) {
       // this.egresopost = item.anoegreso;
       // this.cantidad = item.cantidad;
         //     this.codProducto = item.codigo_producto;
        //      this.costoUnitario = item.costo_unitario;
              this.iddeuconx = item.iddeucon;
              this.deudax = item.deuda;
              this.idItemx = item.item;
              this.costoUnitario = item.deuda;
              this.idItem = item.idite;
              this.pagar();
      },

    pagar() {
     
      this.actualizarDatosFactura();
      this.identificador = uuidv4();
      this.nombre_cliente = this.nombres;
      this.apellido_cliente = this.paterno + " " + this.materno;
      this.codigo_cliente = this.unicodigo;
      this.numero_documento = this.numeroNit;
      this.razon_social = this.nombreFactura;
      if (this.selectDocumento == "PASAPORTE") {
        this.selectDocumento = "PSP";
      }
      this.codigo_tipo_documento = this.selectDocumento;

     // if (this.Seleccionados.length > 0) {
        var valueToPush = {};
        //for (let j = 0; j < this.Seleccionados.length; j++) {
          //valueToPush.concepto = " - " + this.detalle[j].item + " - " + this.apellido_cliente +  " - " +  this.nombre_cliente +  " - " +  this.carrera;
          var valueToPush = {};
          valueToPush.concepto = this.idItemx;
          valueToPush.cantidad = 1;
          valueToPush.costo_unitario = this.deudax;
          valueToPush.descuento_unitario = 0;

          if (
            this.iddeuconx > 0 &&
            this.iddeuconx < 10
          ) {
            valueToPush.codigo_producto =
              "UNI 00" + this.iddeuconx;
          } else if (
            this.iddeuconx > 9 &&
            this.iddeuconx < 100
          ) {
            valueToPush.codigo_producto =
              "UNI 0"+ this.iddeuconx;
          } else if (
            this.iddeuconx > 99 &&
            this.iddeuconx < 12000
          ) {
            valueToPush.codigo_producto =
              "UNI" + " " + this.iddeuconx;
          }

          valueToPush.codigo_producto_sin = "99100";

          this.det.push(valueToPush);
        //}

        for (let x = 0; x < 3; x++) {
          switch (x) {
            case 0:
              this.md[x].nombre = "Estudiante";
              this.md[x].dato = this.nombreCompleto;

              break;
            case 1:
              this.md[x].nombre = "Periodo Facturado";
              this.md[x].dato = this.fechaFactura;

              break;
            case 2:
              switch (this.id_sede) {
                case 1:
                  this.md[x].nombre = "Sede";
                  this.md[x].dato = "Cochabamba";
                  break;
                case 2:
                  this.md[x].nombre = "Sede";
                  this.md[x].dato = "Santa Cruz";
                  break;
                case 3:
                  this.md[x].nombre = "Sede";
                  this.md[x].dato = "La Paz";
                  break;
                default:
                  break;
              }
            default:
              break;
          }
        }
     // }
      //console.log(this.det);
      this.det1 = JSON.stringify(this.det);
      this.det2 = this.det1.replaceAll(",", "xx");

      this.md1 = JSON.stringify(this.md);
      this.md2 = this.md1.replaceAll(",", "xx");

      //  this.callBack= "http://216.158.233.122:3009/pagos/guardartextolibelula1?cduuid=$" + this.identificador +"&gestion=$" + this.idGestion+"&unicodico=$" + this.unicodigo + "&sd=$"+ this.id_sede + "&ple=$" + this.idPlanestudio;
      this.callBack =
        "http:xxxx216.158.233.122:3009xxpagosxxguardartextolibelula1?cduuid=$" +
        this.identificador +
        "&gestion=$" +
        this.id_gestion +
        "&unicodico=$" +
        this.unicodigo +
        "&sd=$" +
        this.id_sede +
        "&ple=$" +
        this.idPlanestudio;
      this.callApi(
        this.identificador,
        this.email_cliente,
        this.nombre_cliente,
        this.apellido_cliente,
        this.codigo_cliente,
        this.numero_documento,
        this.razon_social,
        this.codigo_tipo_documento,
        this.det2,
        this.md2,
        this.callBack
      );

     // this.singleSelect="";
     // for (let i = 0; i < this.det.length; i++) {
       //       this.cantidad = this.det[i].cantidad;
         //     this.codProducto = this.det[i].codigo_producto;
           //   this.costoUnitario = this.det[i].costo_unitario;
            //  this.descUnitario = this.det[i].descuento_unitario;
            //  this.concepto = this.det[i].concepto;
             // this.idItem = this.Seleccionados[i].idite;
             // console.log(this.idItem);
             
              
              //me.cambiarEstadoMolinete();
            //}

      //this.Seleccionados=[];
      ///this.identificador="";
      this.det=[];
      




    },
    async callApi(
      identificador,
      email_cliente,
      nombre_cliente,
      apellido_cliente,
      codigo_cliente,
      numero_documento,
      razon_social,
      codigo_tipo_documento,
      det2,
      md2,
      callBack
    ) {
      let me = this;
      await axios
        .post(
          "/estudiante/enviarapasarela/" +
            this.identificador +
            "," +
            this.email_cliente +
            "," +
            this.nombre_cliente +
            "," +
            this.apellido_cliente +
            "," +
            this.codigo_cliente +
            "," +
            this.numero_documento +
            "," +
            this.razon_social +
            "," +
            this.codigo_tipo_documento +
            "," +
            this.det2 +
            "," +
            this.md2 +
            "," +
            this.idGestion +
            "," +
            this.id_sede +
            "," +
            this.idPlanestudio +
            "," +
            this.idItem +
            "," +
            this.costoUnitario
        )
        .then(function (response) {
         // me.mensajeSnackbar = response.data.message;
          me.libelulaurl = response.data.urls;
         // me.snackbarOK = true;
          me.abrirNuevaVentana(me.libelulaurl);
        //  if (me.libelulaurl != null) {
        // console.log(me.Seleccionados[0].idite);
             //for
        //    me.guardarIntentoPago();  
            //me.verificarIdentificadorLibelula();
         // } // if
        })
        .catch(function (error) {
          me.mensajeSnackbar = response.data.message;
          me.snackbarError = true;
          console.log(error.response.data.message);
        });
    },
    async cambiarEstadoMolinete() {
      let me = this;

      await axios
        .post(
          "/molinetes/addMolinetes/" +
            this.numero_documento +
            "," +
            this.deptCode +
            "," +
            this.nombre_cliente +
            "," +
            this.paterno +
            "," +
            this.numeroTarjeta +
            "," +
            this.accLevelIds +
            "," +
            this.fechaVencimientoActual1 +
            "," +
            this.nuevaFechaVencimiento1
        )
        .then(function (response) {
          me.mensajeSnackbar = response.data.message;
          me.snackbarOK = true;
        })
        .catch(function (error) {
          me.snackbarError = true;
        });
    },
    sacarFechaActual(){
   this.fechaVencimientoActual1 = new Date();
   this.fechaVencimientoActual1 = 
   this.fechaVencimientoActual1.getFullYear()+ "-" + 
   (this.fechaVencimientoActual1.getMonth() +1) + "-" + this.fechaVencimientoActual1.getDate() ;
    
         
 },
    async guardarIntentoPago() {
      let me = this;

      await axios
        .post(
          "/estudiante/guardarIntentoPago/" +
            this.codigo_cliente +
            "," +
            this.id_sede +
            "," +
            this.concepto +
            "," +
            this.cantidad +
            "," +
            this.costoUnitario +
            "," +
            this.descUnitario +
            "," +
            this.codProducto +
            "," +
            this.identificador +
            "," +
            this.idPlanestudio +
            "," +
            this.idGestion +
            "," +
            this.idItem
        )
        .then(function (response) {
          me.verificarIdentificadorLibelula();
        })
        .catch(function (error) {
          me.snackbarError = true;
        });
    },
    abrirNuevaVentana(libelulaurl) {
      var url = "http://midominio.com/consultar?";
      url += "variable=" + this.libelulaurl;

      var nuevaVentana = window.open(
        this.libelulaurl,
        "TituloParaLaNuevaVentana"
      );
      if (nuevaVentana) {
        nuevaVentana.focus();
      }
    },
    limpiar() {
      this.identificador = "";
      this.Seleccionados = [];
      this.det = [];
    },
    async listarGestion() {
      let me = this;
      await axios
        .get("/estudiante/buscagestionactualinscr/")
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosGestion = [];
          } else {
            me.datosGestion = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
    seleccionarGestion(item) {
      this.gestion = item.nom;
      this.idGestion = item.id_gestion;
      this.gestionModal = false;
      this.listarDeudaest(
        this.unicodigo,
        this.idPlanestudio,
        this.idGestion,
        this.id_sede
      );
    },
    showGestion() {
      this.gestionModal = true;
      this.listarGestion();
    },
    closeGestion() {
      this.gestionModal = false;
    },
    async listarDeudaest(unicodigo, idPlanestudio, idGestion, id_sede) {
      let me = this;
      await axios
        .get(
          "/pagos/listardeudaestlibelula/" +
            this.unicodigo +
            "," +
            this.idPlanestudio +
            "," +
            this.idGestion +
            "," +
            this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosDeuda = [];
          } else {
            me.datosDeuda = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
    seleccionarCarrera(item) {
      this.carrera = item.carre;
      this.idCarrera = item.idcar;
      this.idPlanestudio = item.idplan;
      this.carreraModal = false;
    },
    showCarrera() {
      this.carreraModal = true;
      this.listarCarrera(this.unicodigo);
    },
    closeCarrera() {
      this.carreraModal = false;
    },
    async listarCarrera(unicodigo) {
      let me = this;
      await axios
        .get(
          "/estudiante/listarcarreraestu/" + this.unicodigo + "," + this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosCarrera = [];
          } else {
            me.datosCarrera = response.data.resultado;
          }
        })
        .catch(function (error) {});
    },
    async listarDatosEstudiante(unicodigo, sede) {
      let me = this;
      await axios
        .get(
          "/estudiante/listarDatosEst/" + this.unicodigo + "," + this.id_sede
        )
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosEstudiante = [];
          } else {
            me.datosEstudiante = response.data.resultado;
            me.nombreFactura = me.datosEstudiante[0].nomf;
            if (me.nombreFactura == null) {
              me.nombreFactura = "SIN NOMBRE";
            }
            me.email_cliente = me.datosEstudiante[0].mail;
            if (me.email_cliente == null) {
              me.email_cliente = "sinnombre@mail.com";
            }
            me.selectDocumento = me.datosEstudiante[0].tpf;
            if (me.selectDocumento == "PSP") {
              me.selectDocumento = "PASAPORTE";
            } else {
              if (me.selectDocumento == null) {
                me.selectDocumento = "CI";
              }
            }
            me.numeroNit = me.datosEstudiante[0].nf;
            if (me.numeroNit == null) {
              me.numeroNit = 0;
            }
          }
        })
        .catch(function (error) {});
    },

    getColor(est) {
      if (est == "ACTIVO") return "green";
      else return "red";
    },

    showTpostulante() {
      this.tpostModal = true;
    },
    closeTpost() {
      this.tpostModal = false;
    },
  },
};
</script>
<style>
   .page-number {
     position: absolute;
     bottom: 10px;
     right: 10px;
     font-size: 10px;
     color: #333;
   }
   .my-header-style {
     background: #F0F4C3;
    
   }
   .my-header-style2 {
    background: #FFECB3;
   
  }
   </style>